import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { initialiseNav } from 'common/store/modules/competition-nav/thunks';

/**
 * Resets all navigation filters (competition, season, round) back to their initial default values.
 *
 * @param {object} params - Parameters.
 * @param {object} params.initialValues - Initial values for competition, season, and round to reset to.
 * @param {boolean} [params.removeFinals] - Whether to remove finals from the rounds list.
 * @param {Function} params.onAfterReset - Optional. Called after the reset functionality is triggered.
 * @returns {Function} Reset function.
 */
export const useResetToDefaults = ({
    initialValues,
    removeFinals = false,
    onAfterReset
}) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(
            initialiseNav({
                initialValues,
                removeFinals
            })
        );

        if (onAfterReset) {
            onAfterReset();
        }
    }, [dispatch, initialValues, removeFinals, onAfterReset]);
};

useResetToDefaults.propTypes = {
    initialValues: PropTypes.object.isRequired,
    removeFinals: PropTypes.bool,
    onAfterReset: PropTypes.func
};
